export default [
    {
        path: 'scheduling',
        meta: {
            requiredAuth: true
        },
        component: () => import('../pages/scheduling/Index.vue'),
        children: [
            {
                path: 'register',
                meta: {
                    requiredAuth: true
                },
                component: () => import('../pages/scheduling/Register.vue'),
            },
            {
                path: 'approve',
                meta: {
                    requiredAuth: true
                },
                component: () => import('../pages/scheduling/Approve.vue'),
            },
            {
                path: 'running',
                meta: {
                    requiredAuth: true
                },
                component: () => import('../pages/scheduling/Running.vue'),
            }
        ]
    }

]
